const T = "AUTH_TOKENS", E = "BROWSER_SUPPORT", S = "DEVICE_SETTINGS", _ = "DEVICES", A = "g", R = "LAST_USED_INTEGRATION", O = "NOTIFICATIONS", I = "PLAYER", G = "STREAM_SETTINGS", N = "TEST_CAM_MIC", o = "USER_SETTINGS";
export {
  T as STORAGE_AUTH_TOKENS,
  E as STORAGE_BROWSER_SUPPORT,
  _ as STORAGE_DEVICES,
  S as STORAGE_DEVICE_SETTINGS,
  A as STORAGE_GENERAL,
  R as STORAGE_LAST_USED_INTEGRATION,
  O as STORAGE_NOTIFICATIONS,
  I as STORAGE_PLAYER,
  G as STORAGE_STREAM_SETTINGS,
  N as STORAGE_TEST_CAM_MIC,
  o as STORAGE_USER_SETTINGS
};
